export const PREFERS_SYSTEM_THEME_MODE = 'system';
export const PREFERS_DARK_THEME_MODE = 'dark';
export const PREFERS_LIGHT_THEME_MODE = 'light';
export const DARK_THEME_MODE = 'dark';
export const LIGHT_THEME_MODE = 'light';
export const BRAND_COLOR = "#007fff";